var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCog = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_cog",
    "data-name": "Icon / cog",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.4,
    height: 15.998,
    viewBox: "0 0 15.4 15.998",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cog",
    d: "M32.288,17.395l-1.052-.607a6.3,6.3,0,0,0,0-1.577l1.052-.607a.772.772,0,0,0,.356-.887A7.986,7.986,0,0,0,30.788,10.5a.774.774,0,0,0-.949-.138l-1.05.606a6.261,6.261,0,0,0-1.366-.79V8.969a.775.775,0,0,0-.6-.754,8.056,8.056,0,0,0-3.7,0,.775.775,0,0,0-.6.754v1.213a6.261,6.261,0,0,0-1.366.79l-1.05-.606a.774.774,0,0,0-.949.138,7.986,7.986,0,0,0-1.856,3.212.772.772,0,0,0,.356.887l1.052.607a6.3,6.3,0,0,0,0,1.577l-1.052.607a.772.772,0,0,0-.356.887,7.986,7.986,0,0,0,1.856,3.212.774.774,0,0,0,.949.138l1.05-.606a6.26,6.26,0,0,0,1.366.79v1.213a.775.775,0,0,0,.6.754,8.056,8.056,0,0,0,3.7,0,.775.775,0,0,0,.6-.754V21.816a6.262,6.262,0,0,0,1.366-.79l1.05.606a.774.774,0,0,0,.949-.138,7.986,7.986,0,0,0,1.856-3.212.772.772,0,0,0-.356-.887Zm-2.112,3.24-1.494-.862A5.573,5.573,0,0,1,26.391,21.1v1.725a7,7,0,0,1-2.83,0V21.1a5.574,5.574,0,0,1-2.291-1.324l-1.494.862a6.967,6.967,0,0,1-1.417-2.45l1.494-.862a5.62,5.62,0,0,1,0-2.647l-1.494-.862a6.972,6.972,0,0,1,1.417-2.45l1.494.863A5.565,5.565,0,0,1,23.561,10.9V9.176a6.993,6.993,0,0,1,2.83,0V10.9a5.565,5.565,0,0,1,2.291,1.325l1.494-.863a6.971,6.971,0,0,1,1.417,2.45l-1.494.862a5.619,5.619,0,0,1,0,2.647l1.494.862A6.967,6.967,0,0,1,30.176,20.635Zm-5.2-7.733a3.1,3.1,0,1,0,3.1,3.1A3.1,3.1,0,0,0,24.976,12.9Zm0,5.161A2.064,2.064,0,1,1,27.04,16,2.067,2.067,0,0,1,24.976,18.063Z",
    transform: "translate(-17.276 -8)",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCog);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cog.3dbfa64b294543f41c30cd117c880963.svg";